<template>
    <v-container fluid>
        <!-- start ROI Dialog -->
        <v-row justify="center">
        <v-dialog transition="dialog-top-transition" v-model="definedModal" persistent max-width="800px">
            <v-card>
            <v-form ref="downloadPdfForm" lazy-validation>
                <v-toolbar color="primary" dark> <span class="text-h5">Geração do ROI de Venda</span></v-toolbar>
                <v-card-text style="padding-bottom: 0px;">
                    <v-row>
                        <v-col>
                            <RevenueValueField :roiType="roiType" :proposalType="proposalType" :proposal="proposal" />
                        </v-col>
                        <v-col>
                            <TaxField :roiType="roiType" :proposalType="proposalType" :proposal="proposal" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <TotalInstallmentsField :roiType="roiType" :proposalType="proposalType" :proposal="proposal" />
                        </v-col>
                        <v-col>
                            <FixedEntryValueField :roiType="roiType" :proposalType="proposalType" :proposal="proposal" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <CostsAdditional :roiType="roiType" :proposalType="proposalType" :proposal="proposal" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <MonthlyCosts :roiType="roiType" :proposalType="proposalType" :proposal="proposal" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <Investors :roiType="roiType" :proposalType="proposalType" :proposal="proposal" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="() => closeModal()" 
                        :loading="isLoadingROI" 
                        :disabled="isLoadingROI"
                    >Cancelar</v-btn>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="() => generate()" 
                        :loading="isLoadingROI" 
                        :disabled="isDisabledROI"
                    >Gerar</v-btn>
                </v-card-actions> 
            </v-form>
            </v-card>
        </v-dialog>
        </v-row>
        <!-- end ROI Dialog -->
    </v-container>
</template>
<script>
import { mapActions } from "vuex";
import RoiApi from '@/services/apiPdf/RoiApi.js'
import Investors from '@/components/ROI/Investors.vue'
import CostsAdditional from '@/components/ROI/CostsAdditional.vue'
import MonthlyCosts from '@/components/ROI/MonthlyCosts.vue'
import TaxField from '@/components/ROI/TaxField.vue'
import TotalInstallmentsField from '@/components/ROI/TotalInstallmentsField.vue'
import FixedEntryValueField from '@/components/ROI/FixedEntryValueField.vue'
import RevenueValueField from '@/components/ROI/RevenueValueField.vue'
import WaterScanService from '@/services/firebase/WaterScan/WaterScanService';
import Utils from "@/scripts/Utils";

export default {
    props: {
        modal: {
          type: Boolean,
          require: true,
          default: false,
        },
        // Parâmetros obrigatórios
        proposalType: {
          type: String,
          require: true,
        },
        idProposal: {
          type: String,
          require: true,
        },
    },
    components: {
        Investors,
        CostsAdditional,
        MonthlyCosts,
        TaxField,
        TotalInstallmentsField,
        FixedEntryValueField,
        RevenueValueField,
    },
    data: () => ({
        definedModal: false,
        definedLoading: false,
        definedDisabled: false,
        identification: null,
        roiType: 'sales',
        proposal: null,
        disabled: {
            'tax': false,
            'costsAdditional': false,
            'investors': false,
            'totalInstallments': false,
            'fixedEntryValue': false,
            'revenueValue': false,
        },
        loading: {
            'tax': false,
            'costsAdditional': false,
            'investors': false,
            'monthlyCosts': false,
            'totalInstallments': false,
            'fixedEntryValue': false,
            'revenueValue': false,
        },
    }),
    computed: {
        isOpenROIModal() {
            return this.definedModal
        },
        isLoadingROI() {
            return this.definedLoading || this.hasLoading
        },
        isDisabledROI() {
            return this.isLoadingROI || this.definedDisabled || this.hasDisabled
        },
        hasLoading() {
            return Object.values(this.loading).reduce((prev, cur) => prev || cur, false)
        },
        hasDisabled() {
            return Object.values(this.disabled).reduce((prev, cur) => prev || cur, false)
        },
    },
    methods: {
        ...mapActions([
            'subscribeChannel',
        ]),
        openROIModal() {
            this.definedModal = true
        },
        emitModal() {
            this.$emit('close')
        },
        closeModal() {
            this.definedModal = false
            this.tax = 0
            this.emitModal()
        },
        async generate() {
            this.definedLoading = true
            await RoiApi.generateSalesRoiPdf(
                this.identification, {
                proposalType: 'waterscan',
                idProposal: this.idProposal,
            })
            this.definedLoading = false
        },
        async fetchProposal(idProposal) {
            // ------------------------------------
            // Buscar a proposta
            try {
                if (this.proposalType == 'waterscan') {
                    this.proposal = await WaterScanService.getProposalById(idProposal)
                    this.identification = this.proposal.locationInformation.name
                } else {
                    
                }
                this.definedLoading = false
            } catch (e) {
                console.error(e)
                this.definedLoading = false
            }
        },
    },
    watch: {
        async modal(newValue) {
            this.definedModal = newValue
            this.proposal = Utils.copyObject(this.proposal)
        },
        async idProposal(newValue) {
            if (newValue) await this.fetchProposal(newValue)
        },
    },
    created() {
        this.subscribeChannel({
            channel: 'roi',
            events: [
                // -----------------------------------------------------
                // Imposto
                {
                    event: 'sales-roi.tax',
                    fn: (tax) => {
                        this.proposal['sales-roi'].tax = tax
                    }
                }, 
                {
                    event: 'sales-roi.tax:loading',
                    fn: (status) => {
                        this.loading['tax'] = status
                    }
                }, 
                {
                    event: 'sales-roi.tax:disabled',
                    fn: (status) => {
                        this.disabled['tax'] = status
                    }
                },
                // -----------------------------------------------------
                // Custos Adicionais
                {
                    event: 'sales-roi.costsAdditional',
                    fn: (costsAdditional) => {
                        this.proposal['sales-roi'].costsAdditional = costsAdditional
                    }
                }, 
                {
                    event: 'sales-roi.costsAdditional:loading',
                    fn: (status) => {
                        this.loading['costsAdditional'] = status
                    }
                }, 
                {
                    event: 'sales-roi.costsAdditional:disabled',
                    fn: (status) => {
                        this.disabled['costsAdditional'] = status
                    }
                },
                // -----------------------------------------------------
                // Investidores
                {
                    event: 'sales-roi.investors',
                    fn: (investors) => {
                        this.proposal['sales-roi'].investors = investors
                    }
                }, 
                {
                    event: 'sales-roi.investors:loading',
                    fn: (status) => {
                        this.loading['investors'] = status
                    }
                }, 
                {
                    event: 'sales-roi.investors:disabled',
                    fn: (status) => {
                        this.disabled['investors'] = status
                    }
                },
                // -----------------------------------------------------
                // Custos Mensais
                {
                    event: 'sales-roi.monthlyCosts',
                    fn: (monthlyCosts) => {
                        this.proposal['sales-roi'].monthlyCosts = monthlyCosts
                    }
                }, 
                {
                    event: 'sales-roi.monthlyCosts:loading',
                    fn: (status) => {
                        this.loading['monthlyCosts'] = status
                    }
                }, 
                {
                    event: 'sales-roi.monthlyCosts:disabled',
                    fn: (status) => {
                        this.disabled['monthlyCosts'] = status
                    }
                },
                // -----------------------------------------------------
                // Total de parcelas
                {
                    event: 'sales-roi.totalInstallments',
                    fn: (totalInstallments) => {
                        this.proposal['sales-roi'].totalInstallments = totalInstallments
                    }
                }, 
                {
                    event: 'sales-roi.totalInstallments:loading',
                    fn: (status) => {
                        this.loading['totalInstallments'] = status
                    }
                }, 
                {
                    event: 'sales-roi.totalInstallments:disabled',
                    fn: (status) => {
                        this.disabled['totalInstallments'] = status
                    }
                },
                // -----------------------------------------------------
                // Valor de entrada
                {
                    event: 'sales-roi.fixedEntryValue',
                    fn: (fixedEntryValue) => {
                        this.proposal['sales-roi'].fixedEntryValue = fixedEntryValue
                    }
                }, 
                {
                    event: 'sales-roi.fixedEntryValue:loading',
                    fn: (status) => {
                        this.loading['fixedEntryValue'] = status
                    }
                }, 
                {
                    event: 'sales-roi.fixedEntryValue:disabled',
                    fn: (status) => {
                        this.disabled['fixedEntryValue'] = status
                    }
                },
                // -----------------------------------------------------
                // Valor de receita
                {
                    event: 'sales-roi.revenueValue',
                    fn: (revenueValue) => {
                        this.proposal['sales-roi'].revenueValue = revenueValue
                    }
                }, 
                {
                    event: 'sales-roi.revenueValue:loading',
                    fn: (status) => {
                        this.loading['revenueValue'] = status
                    }
                }, 
                {
                    event: 'sales-roi.revenueValue:disabled',
                    fn: (status) => {
                        this.disabled['revenueValue'] = status
                    }
                },
            ]
        })
    },
}

</script>